import { NAVIGATION_ITEM_TABLE_ENUM } from "modules/project/hooks/useProjectNavigation"

export const datasetTypes = [
  {
    label: "Crypto screener",
    value: NAVIGATION_ITEM_TABLE_ENUM.CRYPTO_SCREENER,
  },
  {
    label: "Fundraises",
    value: NAVIGATION_ITEM_TABLE_ENUM.FUNDRAISES,
  },
  {
    label: "Top tokenholders",
    value: NAVIGATION_ITEM_TABLE_ENUM.TOP_TOKENHOLDERS,
  },
  {
    label: "Insider transactions",
    value: NAVIGATION_ITEM_TABLE_ENUM.INSIDER_TRANSACTIONS,
  },
  {
    label: "Stablecoins",
    value: NAVIGATION_ITEM_TABLE_ENUM.STABLECOINS,
  },
  {
    label: "Trending contracts",
    value: NAVIGATION_ITEM_TABLE_ENUM.TRENDING_CONTRACTS,
  },
  {
    label: "Trending wallets",
    value: NAVIGATION_ITEM_TABLE_ENUM.TRENDING_WALLETS,
  },
  {
    label: "Project contracts",
    value: NAVIGATION_ITEM_TABLE_ENUM.PROJECT_CONTRACTS,
  },
  {
    label: "Cohort analysis",
    value: NAVIGATION_ITEM_TABLE_ENUM.COHORT_ANALYSIS,
  },
  {
    label: "Blockchain comparison",
    value: NAVIGATION_ITEM_TABLE_ENUM.BLOCKCHAIN_COMPARISON,
  },
]
